import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const portalApi = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Kirim karyawan_token via header (fallback kalau cookie tidak terkirim di iOS Safari)
portalApi.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("karyawan_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export default portalApi;
